import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import Paragraph from './Paragraph';
import CompletionPieChart from './CompletionPieChart';
import Typography from '@mui/material/Typography';
import { getAuth } from 'firebase/auth';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const WelcomeMessage = () => {
    const [userName, setUserName] = useState('');
    const [completed, setCompleted] = useState(0);
    const [total, setTotal] = useState(0);
    const isMobile = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        const fetchUserName = async () => {
            const auth = getAuth();
            const user = auth.currentUser;
            if (user) {
                const userDocRef = doc(db, "users", user.uid);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    const fullName = `${userData.firstName} ${userData.lastName}`;
                    setUserName(fullName);
                } else {
                    console.error("User document does not exist");
                }
            }
        };

        const fetchModules = async () => {
            const modulesCollection = collection(db, "modules");
            const modulesSnapshot = await getDocs(modulesCollection);
            let allLessons = [];
            modulesSnapshot.forEach(doc => {
                const moduleData = doc.data();
                if (moduleData.type === "module") {
                    const lessons = JSON.parse(moduleData.lesson);
                    allLessons = allLessons.concat(lessons);
                }
            });
            setTotal(allLessons.length);

            const auth = getAuth();
            const user = auth.currentUser;
            if (user) {
                const userDocRef = doc(db, "users", user.uid);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    const completedLessons = JSON.parse(userData.lessons);
                    const uniqueCompletedLessons = [...new Set(completedLessons)];
                    const completedCount = uniqueCompletedLessons.filter(lesson => allLessons.includes(lesson)).length;
                    setCompleted(completedCount);
                }
            }
        };

        fetchUserName();
        fetchModules();
    }, []);

    return (
        <>
            <Stack direction="row" spacing={4}>
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Paragraph>
                        {`<b style='color: #333333;'>Welcome to Learncmd, ${userName}!</b>`}
                    </Paragraph>
                    <Paragraph>
                        {"Get ready to master the terminal and take your command-line skills to the next level."}
                    </Paragraph>
                    <Paragraph>
                        {"Below, you'll find the course modules designed to guide you step by step. Don't forget to explore the side menu for additional resources. Before you dive in, "}
                        <Link to="/introduction" style={{ color: '#006666', textDecoration: 'underline', fontWeight: 'bold' }}>
                            click here
                        </Link>
                        {" for a quick introduction on how to get the most out of this course."}
                    </Paragraph>
                    <Paragraph>
                        {"Complete all the modules to earn your certificate, which you can find in your Profile page. It's a great way to showcase your terminal expertise and enhance your resume."}
                    </Paragraph>
                    <Box sx={{ height: 40 }} />
                    {isMobile && (
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <CompletionPieChart title="Course Progress" completed={completed} total={total} showLegend={true} />
                        </Box>
                    )}
                </Stack>
                {!isMobile && <CompletionPieChart title="Course Progress" completed={completed} total={total} showLegend={true} />}
            </Stack>
            <Box sx={{ height: 40 }} />
        </>
    );
};

const WalkthroughMessage = () => {
    return (
        <Stack spacing={2}>
            <Paragraph>
                {`Explore our Walkthroughs to dive deep into popular terminal commands.`}
            </Paragraph>
            <Box sx={{ height: 40 }} />
        </Stack>
    );
};

const ArticleMessage = () => {
    return (
        <Stack spacing={2}>
            <Paragraph>
                {`Explore our Walkthroughs to dive deep into popular terminal commands.`}
            </Paragraph>
            <Box sx={{ height: 40 }} />
        </Stack>
    );
};

export { WelcomeMessage, WalkthroughMessage };